import { Component, computed, DestroyRef, inject, input, output, Signal, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { BuildInfo } from '@iot-platform/models/common';
import { shareReplay } from 'rxjs/operators';
import { ReleaseNotesService } from '../release-notes';
import { BuildInfoService } from './services/build-info.service';

@Component({
  selector: 'iot-platform-ui-build-info',
  templateUrl: './build-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./build-info.component.scss']
})
export class BuildInfoComponent {
  private readonly buildInfoService: BuildInfoService = inject(BuildInfoService);
  private readonly releaseNotesService: ReleaseNotesService = inject(ReleaseNotesService);
  label = input<string>();
  build = input<BuildInfo>();
  showBuildNumber = input<boolean>(true);
  showChangelog = input<boolean>(true);
  openReleaseNotes = output<boolean>();
  openChangelog = output<boolean>();
  protected readonly destroyRef: DestroyRef = inject(DestroyRef);
  changeLog: Signal<string | undefined> = toSignal(this.releaseNotesService.getChangelog().pipe(takeUntilDestroyed(this.destroyRef)));
  buildInfo: Signal<BuildInfo> = toSignal(this.buildInfoService.getBuildInfo().pipe(shareReplay(1), takeUntilDestroyed(this.destroyRef)));
  computedBuildInfo: Signal<BuildInfo> = computed(() => {
    const build = this.build();
    const buildInfo = this.buildInfo();
    return build ?? buildInfo;
  });
}
